/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 HPC_Expansion_LITE.glb --transform --simplify --ratio 0.5 --draco 
Files: HPC_Expansion_LITE.glb [11.78MB] > C:\Users\eviei\Desktop\MODELOSORION\hpc\HPC_Expansion_LITE-transformed.glb [523.96KB] (96%)
*/

import React from 'react'
import { useGLTF } from '@react-three/drei'

export function ExpansionHPC(pos) {
  const { nodes, materials } = useGLTF('/models/hpc2-transformed.glb')
  return (
    <group position={[pos[0],pos[1],pos[2]-1]}  dispose={null} rotation={[-Math.PI / 2,0,Math.PI / 2]}>
      <mesh geometry={nodes['torque_nut_01_iso_ISO_7040-M3-NA2012'].geometry} material={materials.PaletteMaterial002} />
      <mesh geometry={nodes['torque_nut_01_iso_ISO_7040-M3-NA2012_1'].geometry} material={materials.PaletteMaterial001} />
    </group>
  )
}

useGLTF.preload('/models/hpc2-transformed.glb')

